import { createFileRoute } from '@tanstack/react-router'
import { PartsDatabase } from 'pages/partsDatabase/PartsDatabase'

export const Route = createFileRoute('/parts/$siteID/')({
  component: RouteComponent,
  staticData: {
    title: 'Parts',
  },
})

function RouteComponent() {
  return (
    <>
      <PartsDatabase />
    </>
  )
}
